
import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable()
export class ProductDetailsService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  
  GetAllItemMasterHeaderSubDescByIdSubIdFetch(  ItemMasterHeaderIds : number , ItemMasterHeaderSubIds  : number    ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
      
  };
 

 return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllItemMasterHeaderSubDescByIdSubId?ItemMasterHeaderId="+ItemMasterHeaderIds+"&ItemMasterHeaderSubId="+ItemMasterHeaderSubIds,httpOptions);

 // return this.http.get("http://localhost:57597/api/ItemMasterAddon/GetAllItemMasterHeaderSubDescByIdSubId?ItemMasterHeaderId="+ItemMasterHeaderIds+"&ItemMasterHeaderSubId="+ItemMasterHeaderSubIds,httpOptions);



  }
  


  getAllSKUHeaderMAPPINGSKUCodeData( skcode:string ) {

    var httpOptions = {
    headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

       })
     };

    return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllSKUHeaderMAPPINGSKUCode?SKUCode="+skcode,httpOptions);

  }

  getProductDetailsBySKUData(  skucode:string) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/getproductdetailsbysku?skucode="+skucode,httpOptions);
  }
  
  getAllCOLLECTIOBulkBySKUData(  Id:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
   return this.http.get(""+this.apiUrl+"/WebsiteHome/getAllCOLLECTIOBulkBySKU?ItemVariationId="+Id,httpOptions);

  //return this.http.get("http://localhost:57597/api/WebsiteHome/getAllCOLLECTIOBulkBySKU?ItemVariationId="+Id,httpOptions);


  }


  
 
  getAllCOLLECTIOBulkData( ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/ItemMasterBasic5_OfferingWholeSaleInfo/GetAllItemMasterBasic5_OfferingWholeSale",httpOptions);

  //return this.http.get("http://localhost:57597/api/ItemMasterBasic5_OfferingWholeSaleInfo/GetAllItemMasterBasic5_OfferingWholeSale",httpOptions);


  } 
   
  UploadbulkStatusUpdateData1(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
   
   //  http://localhost:57597/
  
   return this.http.post<any>(""+this.apiUrl+"/WebsiteHome/UploadBulkStatusUpdate", data
  
   // return this.http.post<any>("http://localhost:57597/api/WebsiteHome/UploadBulkStatusUpdate", data


    //, {
    //  reportProgress: true,
  //  observe: 'events'
  //}

  );
  }     
   
  UploadbulkStatusUpdateData( Ids:number , cb:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
   
   //  http://localhost:57597/
  
   //return this.http.post<any>("https://adminapisnew.hideandskin.in/api/WebsiteHome/UploadBulkStatusUpdate", data
  
  //return this.http.get("http://localhost:57597/api/WebsiteHome/getAllCOLLECTIOBulkBySKU?ItemVariationId="+Id,httpOptions);

  //  return this.http.post<any>("http://localhost:57597/api/WebsiteHome/UploadBulkStatusUpdate?Id="+Ids+"&CreatedBy="+cb, httpOptions);

   return this.http.post<any>(""+this.apiUrl+"/WebsiteHome/UploadBulkStatusUpdate?Id="+Ids+"&CreatedBy="+cb, httpOptions);


    //, {
    //  reportProgress: true,
  //  observe: 'events'
  //}

 // );
  }  
  
  getAllCOLLECTIOBulkSelectiveData(  SelectiveCreatedBys:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
   return this.http.get(""+this.apiUrl+"/ItemMasterBasic5_OfferingWholeSaleInfo/GetAllItemMasterBasic5_OfferingWholeSaleSelective?CreatedBy="+SelectiveCreatedBys,httpOptions);
   
   // return this.http.get("http://localhost:57597/api/ItemMasterBasic5_OfferingWholeSaleInfo/GetAllItemMasterBasic5_OfferingWholeSaleSelective?CreatedBy="+SelectiveCreatedBys,httpOptions);
   

  }
    
  getAllCOLLECTIOBulkSelectiveDelData( CreatedBys:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
     
  return this.http.get(""+this.apiUrl+"/ItemMasterBasic5_OfferingWholeSaleInfo/GetAllItemMasterBasic5_OfferingWholeSaleSelectiveDel?CreatedBy="+CreatedBys,httpOptions);
   
    //  http://localhost:57597

   // return this.http.get("http://localhost:57597/api/ItemMasterBasic5_OfferingWholeSaleInfo/GetAllItemMasterBasic5_OfferingWholeSaleSelectiveDel?CreatedBy="+CreatedBys,httpOptions);
   

  }
 
  GetAllItemMasterBasic8_CouponDetailsByCouponCode(  CC:string, SKUCodes:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
 // return this.http.get("https://adminapisnew.hideandskin.in/api/ItemBasic8_Coupon/GetAllItemMasterBasic8_CouponDetailsByCouponCode?ItemId="+ItemId+"&ItemMasterHeaderId="+ItemMasterHeaderId,httpOptions);

 //   return this.http.get("https://adminapisnew.hideandskin.in/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);

  
 
 return this.http.get(""+this.apiUrl+"/ItemBasic8_Coupon/GetAllItemMasterBasic8_CouponDetailsByCouponCode?CouponCode="+CC+"&SKUCode="+SKUCodes,httpOptions);

// return this.http.get("http://localhost:57597/api/ItemBasic8_Coupon/GetAllItemMasterBasic8_CouponDetailsByCouponCode?CouponCode="+CC+"&SKUCode="+SKUCodes,httpOptions);


  }



}
